import React                  from "react";
import PropTypes              from "prop-types";
import {userType}             from "./FeedHelper";
import {getCommonTranslation} from "../../utils/TranslationHelper";
import Flux                   from "../../flux/Flux";
import {VXPay}                from "../../utils/VXPay";
import Translations           from '../../utils/Translations';
import EnumGA4Events          from '../../utils/EnumGA4Events';
import {generateKey, getCurrencySymbol, getStaticAmount} from "../../utils/CommonUtils";

const MIN_MANUAL_TIP = getStaticAmount('feedMinTippingAmount');
const MAX_MANUAL_TIP = getStaticAmount('feedMaxTippingAmount');
const TIPS           = getStaticAmount('feedTippingAmounts');

export default class FeedTipping extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			selectedTip:       null,
			selectedManualTip: '',
			isManualTip:       false,
			tipHasSend:        false,
			manualError:       '',
		};

		this.isTipping = false;

		this.setTip        = this.setTip.bind(this);
		this.setManualTip  = this.setManualTip.bind(this);
		this.onBlur        = this.onBlur.bind(this);
		this.onFocus       = this.onFocus.bind(this);
		this.sendTip       = this.sendTip.bind(this);
		this.resetTip      = this.resetTip.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
	}

	setTip(value) {
		if (value === this.state.selectedTip) {
			this.setState({selectedTip: null, isManualTip: false});
		} else {
			this.setState({selectedTip: value, isManualTip: false, manualError: ''});
		}
	}

	setManualTip(e) {
		const value = e.target.value;
		if (parseInt(value) > MAX_MANUAL_TIP) {
			this.setState({manualError:  Translations.get("feed.max-tip",MAX_MANUAL_TIP + " " + getCurrencySymbol())});
		} else if (parseInt(value) < 0) {
			this.setState({manualError:  Translations.get("feed.min-tip",MIN_MANUAL_TIP + " " + getCurrencySymbol())});
		} else {
			this.setState({isManualTip: true, selectedManualTip: value, manualError: ''});
		}
	}

	onBlur(e) {
		if (!e.target.value) {
			this.setState({isManualTip: false});
		}
	}

	onFocus() {
		if (!this.state.isManualTip) {
			this.setState({isManualTip: true, selectedTip: null});
		}
	}

	sendTip() {
		if (!this.isTipping) {
            const amount   = this.state.selectedTip || parseInt(this.state.selectedManualTip);
			if (amount) {
                if (amount < MIN_MANUAL_TIP) {
                    this.setState({manualError:  Translations.get("feed.min-tip",MIN_MANUAL_TIP + " " + getCurrencySymbol())});
                } else {
                    this.isTipping = true;
                    if (Flux.Guest.getBalance() >= amount) {
                        const trackerContext = {
                            [EnumGA4Events.DEFAULT_PARAMETER_ITEMS__ITEM_CATEGORY]:
                                this.props.isTippingGoal ?
                                    EnumGA4Events.DEFAULT_PARAMETER_ITEMS__ITEM_CATEGORY__VALUE_FEED_TIPPING_GOAL :
                                    EnumGA4Events.DEFAULT_PARAMETER_ITEMS__ITEM_CATEGORY__VALUE_FEED_TIP
                        };

                        Flux.Feed.addTip(this.props.postId, amount, trackerContext, (response) => {
                            if (response.data && response.data.vx.tipPost.success) {
                                this.setState({tipHasSend: true}, () => {
                                    setTimeout(() => {
                                        this.setState({tipHasSend: false}, () => {
                                            //this.props.setShowTipping(false);
                                            setTimeout(() => {
                                                this.resetTip();
                                            }, 0);
                                        });
                                    }, 5000);
                                    Flux.Feed.triggerUpdatePost(this.props.postId);
                                });
                            }
                        });
                    } else {
                        this.isTipping = false;
                        this.setState({selectedTip: null});
                        VXPay.openPaytour();
                    }
                }
			}
		}
	}

	resetTip() {
		this.isTipping = false;
		this.props.setShowTipping(false);
		this.setState({isManualTip: false, selectedTip: null, tipHasSend: false, selectedManualTip: ''});
	}

	getFormatedTip() {
		const tip = this.state.selectedTip || parseFloat(this.state.selectedManualTip);
		if (typeof tip === 'number' && !isNaN(tip) && (tip % 1 !== 0)) {
			const tipArr = tip.toString().split('.');
			return tipArr[0] + (tipArr[1] ? (tipArr[1].length < 2 ? ',' + tipArr[1] + '0' : ',' + tipArr[1]) : '');
		}
		return tip;
	}

	getTippedBadge() {
		return <div className={"feed__tip-item-group feed__tip-item-group--hide" + (this.state.tipHasSend ? " feed__tip-item-group--show" : "")}>
			<button onClick={this.resetTip} className={"feed__tip-item feed__tip-item--success"}>
				<i className="icon -icon-success-rounded-full"></i> {this.getFormatedTip()}{getCurrencySymbol()} {getCommonTranslation('to') + " "}
				{this.props.model.name} {getCommonTranslation('sent')}
			</button>
		</div>;
	}

	handleKeyDown(e) {
		if ([107, 190, 110, 189, 109, 188, 187].includes(e.keyCode) || (this.state.selectedManualTip === "" && e.keyCode === 48) || (this.state.selectedManualTip === "" && e.keyCode === 96)) {
			e.preventDefault();
		}
	}

	getTipping() {
		return <div
			className={"feed__tip-item-group feed__tip-item-group--hide" + (this.props.showTipping && !this.state.tipHasSend ? " feed__tip-item-group--show" : "")}
		>
            {this.state.manualError && <div className="feed__tip-item-error">{this.state.manualError}</div>}
			{TIPS.map((item, index) => (
				<button tabIndex={this.props.showTipping ? 0 : -1}
					key={generateKey(index)}
					className={"feed__tip-item" + (index === 0 ? " feed__tip-item--first" : "") +  (item === this.state.selectedTip ? " feed__tip-item--active" : "")}
					onClick={() => this.setTip(item)}
				>
					{item} {getCurrencySymbol()}
				</button>
			))}
			<div className={"feed__tip-item--input__wrapper"}>
				{this.state.isManualTip && <div className="feed__tip-item-currency">{getCurrencySymbol()}</div>}
				<input className={"feed__tip-item feed__tip-item--input" + (this.state.isManualTip ? " feed__tip-item--active" : "") + (getCurrencySymbol() === Flux.Constants.Currency.VXC ? " feed__tip-item--padding" : "" )}
				       onBlur={this.onBlur}
				       onFocus={this.onFocus}
				       type="number"
				       value={this.state.selectedManualTip}
				       onChange={this.setManualTip}
				       onKeyDown={this.handleKeyDown}
				       placeholder={this.state.isManualTip ?  "0" : getCommonTranslation('amount')}
				       min={MIN_MANUAL_TIP}
				       max={MAX_MANUAL_TIP}
				       pattern="[0-9*]"
				       inputMode={'numeric'}
                       tabIndex={this.props.showTipping ? 0 : -1}
				/>
			</div>
			<button className={
				"feed__tip-item feed__tip-item--button" +
				(!this.state.manualError && (this.state.selectedTip || (this.state.isManualTip && this.state.selectedManualTip)) ? " feed__tip-item--active" : "")
			}
			     onClick={this.sendTip}
                    tabIndex={this.props.showTipping ? 0 : -1}
			>
				{getCommonTranslation('send')}
			</button>
		</div>;
	}

	render() {
		return <div className="feed__tip">
			{this.state.tipHasSend && this.getTippedBadge()}
			{this.getTipping()}
		</div>;
	}
}

FeedTipping.propTypes = {
	showTipping:    PropTypes.bool.isRequired,
	setShowTipping: PropTypes.func,
	postId:         PropTypes.string.isRequired,
	model:          PropTypes.shape(userType).isRequired,
	isMobile:       PropTypes.bool.isRequired,
	isTippingGoal:  PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
};

FeedTipping.defaultProps = {
	setShowTipping: () => {
	},
};
